import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { distinctUntilChanged, pluck } from 'rxjs/operators';
import { CallDataType, State, defaultCallData } from './state';
import { LeadListFiltersDefutlts } from './leads/leads-list/lead-list-filters/lead-list-filters.component';
const state: State = {
    productSearchShowJoblots: false,
    jobLotParams: {
        allowBreakage: 0,
        jobLot: 0,
        jobLotLeadTime: 2,
        supplierId: '',
        productCode: '',
        edited: false,
    },
    modules: {
        cmsNew: true,
        smartSearch: true,
        twilio: true,
        xero: true,
    },
    onlineUsers: [],
    allUsers: [],
    typingUsers: {},
    statusGroups: [],
    domains: [],
    domain: 'ys',
    hideMenu: false,
    isSideBarOpen: true,
    settings: undefined,
    changeTrigger: {
        orders: 0,
        samples: 0,
    },
    updatedOrderLine: undefined,
    updatedOrderBoard: undefined,
    confirmationData: {
        open: false,
        buttonText: 'Confirm',
        title: '',
        detail: '',
        data: undefined,
    },
    errors: [],
    ordersDashboard: [],
    samplesDashboard: [],
    orderDetailBoard: undefined,
    orders: [],
    samples: [],
    ttl: 10,
    user: undefined,
    device: null,
    asideOpen: false,
    chatStore: {
        unread: 0,
        groups: [],
        group: undefined,
        replyingTo: undefined,
        messages: [],
        subject: null,
        toUser: null,
    },
    faq: {
        data: [],
        params: {
            freetext: '',
            id: 0,
            limit: 8,
            limits: [8, 16, 24, 32, 64],
            page: 0,
            pages: 0,
            pageArray: [],
            totalRecords: 0,
            sort: 'faq_topic.sortOrder',
            sorts: [],
        },
    },
    baskets: {
        data: [],
        params: {
            type: 'order',
            showEmpty: false,
            freeText: '',
            user: '',
            createdBy: '',
            id: '',
            status: '',
            createdAt: undefined,
            lastUpdatedAt: undefined,
            thisWeek: false,
            thisMonth: false,
            limit: 25,
            limits: [25, 50, 75, 100],
            page: 0,
            pages: 0,
            pageArray: [],
            totalRecords: 0,
            sort: 'baskets.lastUpdatedAt DESC',
            sorts: [],
        },
    },
    blogCategories: {
        data: [],
        params: {
            freetext: '',
            id: 0,
            limit: 8,
            limits: [8, 16, 24, 32, 64],
            page: 0,
            pages: 0,
            pageArray: [],
            totalRecords: 0,
            sort: 'blog_category.name',
            sorts: [],
        },
    },
    companyRequests: [],
    notifications: { unread: 0, data: [] },
    growler: {
        errors: [],
        notifications: [],
        simple: '',
        confirmAction: undefined,
    },
    alerts: {
        errors: [],
        notifications: [],
        simple: null,
        confirmAction: null,
        customAlert: null,
        simpleInput: null,
    },
    returnRoute: 'dashboard',
    overlays: {
        companyEdit: false,
        userEdit: false,
        voucherEdit: false,
        userPermissionsEdit: false,
        productTypeConfigure: false,
        postcodeEdit: false,
        postcodeZoneEdit: false,
        zonePostcodes: false,
        busyIndicator: false,
    },
    overlayData: undefined,
    menuOpen: false,
    headerContent: undefined,
    activeMenuItem: { group: '', option: '' },
    menuItems: [
        {
            route: 'dashboard',
            menuGroup: 'dashboard',
            perm: 'adminDashboard',
            title: 'Dashboard',
            icon: 'assets/images/menu-icons/dashboard.svg',
            visibleWhenCollapsed: true,
            active: false,
            collapsed: true,
            backgroundImage: 'assets/images/Dashboard.png',
            subMenus: [],
        },
        {
            route: 'assistant',
            menuGroup: 'assistant',
            perm: 'adminDashboard',
            title: 'Assistant',
            icon: 'assets/images/menu-icons/assistant.svg',
            visibleWhenCollapsed: true,
            active: false,
            collapsed: true,
            backgroundImage: 'assets/images/Dashboard.png',
            subMenus: [],
        },
        {
            route: '',
            menuGroup: 'actions',
            perm: 'adminOrders',
            title: 'Actions',
            icon: 'assets/images/menu-icons/actions.svg',
            active: false,
            collapsed: true,
            toggleChildMenu: false,
            backgroundImage: '',
            subMenus: [
                {
                    route: '/actions',
                    perm: 'ordersView',
                    title: 'Actions Board',
                    active: false,
                    id: 'actionsBoard',
                },
                {
                    route: '/order/create/customer-select',
                    queryParams: { orderType: 'order' },
                    perm: 'ordersView',
                    title: 'Add Order',
                    active: false,
                    id: 'addAction',
                },
                {
                    route: '/order/create/customer-select',
                    queryParams: { orderType: 'quote' },
                    perm: 'ordersView',
                    title: 'Add Quote',
                    active: false,
                    id: 'addQuote',
                },
                {
                    route: '/bespoke-requests',
                    perm: 'ordersView',
                    title: 'Bespoke Requests',
                    active: false,
                },
            ],
        },
        {
            route: '',
            menuGroup: 'orders',
            perm: 'adminOrders',
            title: 'Orders',
            icon: 'assets/images/menu-icons/orders.svg',
            active: false,
            collapsed: true,
            backgroundImage: '',
            visibleWhenCollapsed: true,
            subMenus: [
                {
                    route: '/orders',
                    perm: 'ordersView',
                    title: 'Product Orders',
                    active: false,
                    icon: 'shopping_cart',
                },
                {
                    route: '/orders/samples',
                    perm: 'ordersView',
                    title: 'Sample Orders',
                    active: false,
                    icon: 'work',
                },
                {
                    route: '/orders/quotes',
                    perm: 'ordersView',
                    title: 'Open Quotes',
                    active: false,
                    icon: 'format_quote',
                },
                {
                    route: '/orders/baskets',
                    perm: 'ordersView',
                    title: 'Customer Baskets',
                    active: false,
                    icon: 'shopping_basket',
                },
                {
                    route: '/orders/payments',
                    perm: 'ordersView',
                    title: 'Order Payments',
                    active: false,
                    icon: 'payment',
                },
            ],
        },
        {
            route: '',
            defaultRoute: '/products',
            menuGroup: 'products',
            perm: 'productModule',
            title: 'Products',
            icon: 'assets/images/menu-icons/products.svg',
            active: false,
            collapsed: true,
            backgroundImage: '',
            isBottomMenuItem: true,
            visibleWhenCollapsed: true,
            subMenus: [
                {
                    route: '/products',
                    perm: 'productsView',
                    title: 'Search Products',
                    active: false,
                    icon: 'search',
                },
                {
                    route: '/products/pricing',
                    perm: 'priceTesting',
                    title: 'Price testing',
                    active: false,
                    icon: 'playlist_add_check',
                },
                {
                    route: '/products/calculator',
                    perm: 'priceTesting',
                    title: 'Pricing Calculator',
                    active: false,
                    icon: 'playlist_add_check',
                },
                {
                    route: '/product-ranges',
                    perm: 'productRanges',
                    title: 'Product ranges',
                    active: false,
                    icon: 'multiline_chart',
                },
                {
                    route: '/product-groups',
                    perm: 'productGroups',
                    title: 'Product groups',
                    active: false,
                    icon: 'group_work',
                },
                {
                    route: '/stock',
                    perm: 'productGroups',
                    title: 'Product stock',
                    active: false,
                    icon: 'format_list_numbered',
                },
                {
                    route: '/rewards',
                    title: 'Reward Program',
                    active: false,
                },
                {
                    route: '/product-types',
                    perm: 'productPricing',
                    title: 'Product types',
                    active: false,
                },
                {
                    route: '/product-variables',
                    perm: 'productPricing',
                    title: 'Sku variables',
                    active: false,
                },
                {
                    route: '/product-images-bespoke',
                    perm: 'productPricing',
                    title: 'Product bespoke images',
                    active: false,
                },
                {
                    route: '/product-pricing',
                    perm: 'productPricing',
                    title: 'Product pricing',
                    active: false,
                    icon: 'card_giftcard',
                },
                {
                    route: '/product-pricing/supplier-rates',
                    perm: 'productPricing',
                    title: 'Supplier rate trends',
                    active: false,
                    icon: 'trending_up',
                },
            ],
        },
        {
            route: '',
            menuGroup: 'reporting',
            perm: 'reportingModule',
            title: 'Reporting',
            icon: 'assets/images/menu-icons/reports.svg',
            active: false,
            collapsed: true,
            isBottomMenuItem: true,
            backgroundImage: '',
            visibleWhenCollapsed: true,
            defaultRoute: '/reporting/orders',
            subMenus: [
                {
                    route: '/reporting/orders',
                    perm: 'reportingOrders',
                    title: 'Orders',
                    active: false,
                    icon: 'attach_money',
                },
                {
                    route: '/reporting/calls',
                    perm: 'reportingOrders',
                    title: 'Calls',
                    active: false,
                    icon: 'phonelink_ring',
                },
                {
                    route: '/reporting/sales-kpi',
                    perm: 'reportingOrders',
                    title: 'Sales KPIs',
                    active: false,
                },
                {
                    route: '/reporting/reports',
                    perm: 'reportingOrders',
                    title: 'Smart Reports',
                    active: false,
                },
            ],
        },
        {
            route: '',
            menuGroup: 'job',
            perm: 'jobModule',
            title: 'Jobs',
            icon: 'assets/images/menu-icons/jobs.svg',
            active: false,
            collapsed: true,
            isBottomMenuItem: true,
            backgroundImage: '',
            defaultRoute: '/jobs',
            subMenus: [
                {
                    route: '/jobs',
                    perm: 'jobsList',
                    title: 'View jobs',
                    active: false,
                    icon: 'work',
                },
                {
                    route: '/jobs/applications',
                    perm: 'jobApplications',
                    title: 'View job applications',
                    active: false,
                    icon: 'developer_board',
                },
            ],
        },
        {
            route: 'systemerrors',
            menuGroup: 'systemerrors',
            perm: 'adminDashboard',
            title: 'System errors',
            icon: 'assets/images/menu-icons/system-errors.svg',
            active: false,
            collapsed: true,
            isBottomMenuItem: true,
            defaultRoute: '/systemerrors',
            backgroundImage: 'assets/images/Mask-group.png',
            subMenus: [],
        },
        {
            route: '',
            menuGroup: 'accounts',
            perm: 'adminAccounts',
            title: 'Accounts',
            icon: 'assets/images/menu-icons/account.svg',
            active: false,
            collapsed: true,
            backgroundImage: '',
            subMenus: [
                {
                    route: '/accounts/customer',
                    perm: 'customerModule',
                    title: 'Private',
                    active: false,
                    icon: 'security',
                },
                {
                    route: '/accounts/trade',
                    perm: 'tradeModule',
                    title: 'Trade',
                    active: false,
                    icon: 'compare_arrows',
                },
                {
                    route: '/accounts/supplier',
                    perm: 'supplierModule',
                    title: 'Suppliers',
                    active: false,
                    icon: 'build',
                },
                {
                    route: '/accounts/courier',
                    perm: 'courierModule',
                    title: 'Couriers',
                    active: false,
                    icon: 'local_shipping',
                },
                {
                    route: '/accounts/google/contacts',
                    perm: 'courierModule', // to be changed
                    title: 'Google contacts',
                    active: false,
                    icon: 'contact_phone',
                },
                {
                    route: '/leads',
                    perm: 'customerModule', // to be changed
                    title: 'Leads',
                    active: false,
                    icon: 'contact_phone',
                },
            ],
        },
        {
            route: '',
            menuGroup: 'cms',
            perm: 'cmsModule',
            title: 'CMS',
            icon: 'assets/images/menu-icons/cms.svg',
            active: false,
            collapsed: true,
            backgroundImage: 'assets/images/CMS.png',
            subMenus: [
                {
                    route: '/cms/pages',
                    perm: 'cmsPageEdit',
                    title: 'Pages',
                    active: false,
                    icon: 'pages',
                },
                {
                    route: '/cms/galleries',
                    perm: 'cmsPageEdit',
                    title: 'Galleries',
                    active: false,
                    icon: 'perm_media',
                },
                {
                    route: '/cms/menus',
                    perm: 'cmsPageEdit',
                    title: 'Menus',
                    active: false,
                    icon: 'menu',
                },
                {
                    route: '/blog/articles',
                    perm: 'blogEdit',
                    title: 'Blog Articles',
                    active: false,
                    icon: 'insert_drive_file',
                },
                {
                    route: '/blog/categories',
                    perm: 'blogEdit',
                    title: 'Blog Categories',
                    active: false,
                    icon: 'collections_bookmark',
                },
                {
                    route: '/case-studies',
                    perm: 'cmsPageEdit',
                    title: 'Case Studies',
                    active: false,
                    icon: 'school',
                },
                {
                    route: '/cms/faq',
                    perm: 'faqEdit',
                    title: 'Help Topics & Questions',
                    active: false,
                    icon: 'live_help',
                },
                {
                    route: '/advice',
                    perm: 'faqEdit',
                    title: 'Advice Articles',
                    active: false,
                    icon: 'bar_chart',
                },
                {
                    route: '/cms/user-photo-submissions',
                    perm: 'cmsPageEdit',
                    title: 'Customers Photos',
                    active: false,
                    icon: 'bar_chart',
                },
            ],
        },
        {
            route: '',
            menuGroup: 'cmsNew',
            perm: 'newCMS',
            title: 'CMS New',
            icon: 'assets/images/menu-icons/cms.svg',
            active: false,
            collapsed: true,
            backgroundImage: '',
            subMenus: [
                {
                    route: '/cms-new/sites',
                    title: 'Sites',
                    perm: 'generalAccess',
                    active: false,
                    icon: 'pageview',
                },
                {
                    route: '/cms-new/brands',
                    title: 'Brands',
                    perm: 'generalAccess',
                    active: false,
                    icon: 'view_carousel',
                },
                {
                    route: '/cms-new/spaces',
                    title: 'Spaces',
                    perm: 'generalAccess',
                    active: false,
                    icon: 'menu',
                },
                {
                    route: '/cms-new/pages',
                    title: 'Pages',
                    perm: 'generalAccess',
                    active: false,
                    icon: 'photo_filter',
                },
                {
                    route: '/cms-new/blocks',
                    title: 'Blocks',
                    perm: 'generalAccess',
                    active: false,
                    icon: 'menu',
                },
                {
                    route: '/cms-new/contents',
                    title: 'Collections',
                    perm: 'generalAccess',
                    active: false,
                    icon: 'collections',
                },
                {
                    route: '/cms-new/media',
                    title: 'Media',
                    perm: 'generalAccess',
                    icon: 'featured_video',
                },
            ],
        },
        {
            route: '',
            menuGroup: 'settings',
            perm: 'settingsModule',
            title: 'Settings',
            icon: 'assets/images/menu-icons/settings.svg',
            active: false,
            isBottomMenuItem: true,
            collapsed: true,
            backgroundImage: '',
            defaultRoute: '/settings/general-settings',
            subMenus: [
                {
                    route: '/settings/general-settings',
                    title: 'General Settings',
                    active: false,
                    id: 'general-settings',
                    icon: 'settings',
                },
                {
                    route: '/settings/site-settings',
                    title: 'Site Settings',
                    active: false,
                    id: 'site-settings',
                    icon: 'settings',
                },
                {
                    route: '/settings/call-settings',
                    title: 'Call Settings',
                    id: 'call-settings',
                    active: false,
                    icon: 'settings_phone',
                },
                {
                    route: '/questionnaire',
                    title: 'Questionnaire',
                    id: 'questionnaire',
                    active: false,
                    icon: 'settings_phone',
                },
                {
                    route: '/settings/advanced-settings',
                    title: 'Advanced Settings',
                    id: 'advanced-settings',
                    active: false,
                    icon: 'settings_overscan',
                },

                {
                    route: '/settings/do-ip-settings',
                    title: 'Digital Ocean IPs',
                    id: 'digital-ocean-ips',
                    icon: 'featured_video',
                },
                {
                    route: '/settings/data-grid',
                    title: 'Data Grid',
                    id: 'data-grid',
                    icon: 'featured_video',
                },
            ],
        },
        {
            route: 'elements-catalog',
            menuGroup: 'uiKit',
            perm: 'uiKit',
            title: 'UI Kit',
            icon: 'assets/images/icon-step-3-box.svg',
            visibleWhenCollapsed: true,
            active: false,
            collapsed: true,
            subMenus: [],
        },
    ],
    token: undefined,
    loggedIn: false,
    orderCreateSteps: {
        entry: { active: false, completed: false },
        customer: { active: false, completed: false },
        orders: { active: false, completed: false },
        product: { active: false, completed: false },
        delivery: { active: false, completed: false },
        payment: { active: false, completed: false },
        confirmation: { active: false, completed: false },
        quoteConfirmation: { active: false, completed: false },
    },
    basketId: '',
    basket: {
        type: 'quote',
        lastStep: 'entry',
        source: 'admin',
        potentialQty: 0,
        items: [],
        samples: [],
        rewardsDiscountPercentage: 0,
        voucher: undefined,
        voucherCodeEntered: '',
        deliveryInstructions: '',
        differentDeliveryAddress: false,
        deliveryAddress: undefined,
        deliveryPostcode: '',
        deliveryAddresses: [],
        deliveryRestrictions: [],
        billingAddress: undefined,
        customer: undefined,
        guest: true,
        allowBoards: false,
        gravelDriveway: false,
        discount: {
            type: 'pound',
            value: 0,
        },
        customDelivery: {
            value: 0,
            active: false,
        },
        values: {
            discount: 0,
            gross: 0,
            net: 0,
            vat: 0,
            productDiscount: 0,
            rewardDiscount: 0,
            voucherDiscount: 0,
            adminDiscount: 0,
            delivery: 0,
            deliveryVat: 0,
            preDiscount: {
                net: 0,
                vat: 0,
                gross: 0,
            },
        },
        token: undefined,
        paymentMethod: 'CC',
        shipments: [],
        restrictions: {
            slope: false,
            gravel: false,
            boards: false,
        },
        deliveryOptions: {
            allowPremium: true,
            premium: 0,
            economy: 0,
            geo: {
                travelKM: 0,
                travelMiles: 0,
                travelMinutes: 0,
                lat: undefined,
                lng: undefined,
            },
        },
    },
    call: { ...defaultCallData } as CallDataType,
    cahtReminders: [],
    openedChatSK: undefined,
    confirmationEmail: undefined,
    supplier: undefined,
    accountType: undefined,
    bespokePricingLog: [],
    basketPrevious: undefined,
    activeNotification: undefined,
    cropImage: undefined,
    lastBasketItemAdded: undefined,

    leadsFilters: {
        showFilters: false,
        filters: LeadListFiltersDefutlts,
    },
};
@Injectable()
export class Store {
    private subject = new BehaviorSubject<State>(state);
    private store = this.subject.asObservable().pipe(distinctUntilChanged());
    get value() {
        return this.subject.value;
    }
    select<T>(name: keyof State): Observable<T> {
        // @ts-ignore
        return this.store.pipe(pluck(name));
    }
    selectForLocal<T = any>(name: keyof State): T {
        const d = this.subject.value;
        return d[name] as T;
    }
    set(name: keyof State, newState: any) {
        this.subject.next({
            ...this.value,
            [name]: newState,
        });
    }
    setProp<Type>(name: keyof State, subItem: { [property in keyof Type]?: Type[property] }) {
        this.subject.next({
            ...this.value,
            [name]: {
                ...(this.selectForLocal(name) as Type),
                ...subItem,
            },
        });
    }
}
